var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',[_c('LoginForm',{attrs:{"login-text":"Usuário:","password-text":"Senha:"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }